import jsrsasign from 'jsrsasign';

import keyfile from '../ServiceAccountKey';

// stolen from Paul Rowe, thank you
/*
 * Notes:
 * needed to create a new "Project" in google console
 * needed to create a service account in IAM
 * created a set of keys and stored the file
 * needed to "enable" the Sheets API and the Drive API for the project
 */

const now = Math.trunc(new Date().getTime() / 1000);
const payload = {
    aud: 'https://www.googleapis.com/oauth2/v4/token',
    exp: now + 60 * 30,
    iat: now - 60,
    iss: keyfile.client_email,
    scope: 'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/spreadsheets'
};

const createLocalJWT2 = () => {
    const encodedHeader = jsrsasign.stob64(JSON.stringify({
        'alg': 'RS256',
        'typ': 'JWT'
    }));
    const encodedBody = jsrsasign.stob64(JSON.stringify(payload));
    const sig = new jsrsasign.crypto.Signature({
        alg: 'SHA256withRSA'
    });

    sig.init(keyfile.private_key);
    const signature = jsrsasign.hex2b64(sig.signString(`${encodedHeader}.${encodedBody}`));

    return [encodedHeader, encodedBody, signature].join('.');
};

const exchangeJWTForAccessToken = async (signedJWT) => {
    const body = new URLSearchParams();

    body.append('grant_type', 'urn:ietf:params:oauth:grant-type:jwt-bearer');
    body.append('assertion', signedJWT);
    const response = await fetch('https://www.googleapis.com/oauth2/v4/token', {
        body: body.toString(),
        headers: {
            'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        },
        method: 'POST'

    });

    if (!response.ok) {
        const text = await response.text();

        throw new Error(response.code + text);
    }

    const parsedResponse = await response.json();

    return parsedResponse;
};

export default async () => {
    const jwt2 = createLocalJWT2();
    const accessTokenResponse = await exchangeJWTForAccessToken(jwt2);

    return accessTokenResponse.access_token;
};



// WEBPACK FOOTER //
// ./src/data/ServiceAccountAccess.js